import type { ComponentType } from 'react'
import { ClipboardCheckIcon, DropletIcon, GemIcon } from 'lucide-react'
import {
  DentalImplantIcon,
  MedicalCrossIcon,
  ToothBracesIcon,
  type DentalIconProps,
} from '../components/icons/DentalIcons'

export type Treatment = {
  id: string
  icon: ComponentType<DentalIconProps>
  title: string
  description: string
  message: string
  urgent?: boolean
}

export const treatments: Treatment[] = [
  {
    id: 'valoracion',
    icon: ClipboardCheckIcon,
    title: 'Valoración inicial',
    description:
      'Revisión completa, diagnóstico y plan de tratamiento. El punto de partida para cualquier decisión informada.',
    message: 'Hola, quisiera información sobre la valoración inicial.',
  },
  {
    id: 'limpieza',
    icon: DropletIcon,
    title: 'Limpieza dental',
    description: 'Prevención activa, control de placa y cuidado de encías. Recomendada cada seis meses.',
    message: 'Hola, quisiera información sobre la limpieza dental.',
  },
  {
    id: 'ortodoncia',
    icon: ToothBracesIcon,
    title: 'Ortodoncia',
    description:
      'Opciones para alinear tu sonrisa de forma progresiva con seguimiento profesional continuo.',
    message: 'Hola, quisiera información sobre ortodoncia.',
  },
  {
    id: 'estetica',
    icon: GemIcon,
    title: 'Estética dental',
    description:
      'Soluciones para mejorar color, forma y armonía de tu sonrisa de manera natural y duradera.',
    message: 'Hola, me interesa la estética dental. ¿Podrían orientarme?',
  },
  {
    id: 'implantes',
    icon: DentalImplantIcon,
    title: 'Implantes dentales',
    description:
      'Recupera la funcionalidad y estética de piezas dentales perdidas con un plan personalizado.',
    message: 'Hola, quiero conocer opciones de implantes dentales.',
  },
  {
    id: 'urgencias',
    icon: MedicalCrossIcon,
    title: 'Urgencias odontológicas',
    description:
      'Si tienes dolor que no puede esperar, escríbenos y te orientamos sobre el manejo inicial.',
    message: 'Hola, tengo una urgencia odontológica. ¿Pueden orientarme?',
    urgent: true,
  },
]
